import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function stepperReducer(state = initialState.stepper, action) {
  //updating the state basing on action data
  switch (action.type) {
    case types.SET_STEPPER_STEPS:
      return Object.assign({}, state, {
        steps: action.data,
      });
    case types.SET_STEPPER_ACTIVE_STEP:
      return Object.assign({}, state, {
        activeStep: action.data,
      });
    default:
      return state;
  }
}
